import React from 'react';
import S from './ChatButton.styles';
const ChatButton = ({ chatBtnOpenText = 'Open Chat', chatBtnCloseText = 'Close Chat', }) => {
    const [chatOpen, setChatOpen] = React.useState('disabled');
    function togglePopup() {
        const chatBot = document.querySelector('#chatamo-embeddable-chat-root');
        let chatEvent;
        const chatCheck = chatBot?.querySelector('[data-focus-lock-disabled]');
        if (chatBot) {
            chatEvent = chatOpen === 'disabled' ? 'open_futr' : 'close_futr';
        }
        chatBot?.dispatchEvent(new Event(chatEvent ? chatEvent : 'open_futr'));
        setChatOpen(chatCheck ? chatCheck.getAttribute('data-focus-lock-disabled') : 'disabled');
    }
    return (React.createElement(S.ChatBtn, { type: "button", onClick: () => togglePopup() },
        React.createElement(S.IconHolder, null,
            React.createElement(S.ChatSvg, null)),
        React.createElement(S.ChatBtnTxt, null, chatOpen === 'disabled' ? chatBtnOpenText : chatBtnCloseText)));
};
export default ChatButton;
